export default __webpack_public_path__ + "static/media/bg.18a2fb55.png";